import {InputHTMLAttributes, useMemo} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';
import {useFormControlContext} from '@/components/form/form-control/form-control';

type Options = {
  readOnly: InputHTMLAttributes<HTMLInputElement>['readOnly'];
  isLabelWithingInput?: boolean;
};

export const useTextInputClassName = ({readOnly, isLabelWithingInput = false}: Options, className?: string) => {
  const {isInError, isDisabled, hasWarning} = useFormControlContext();

  return useMemo(
    () =>
      twMerge(
        clsx(
          'w-full rounded-1 border border-charcoal p-4 text-base text-charcoal placeholder-charcoal caret-violet outline-none transition-all',
          'hover:shadow-input focus:border-violet focus:text-violet focus:placeholder-charcoal focus:shadow-inputFocus',
          isInError &&
            'border-red text-red placeholder-red caret-red hover:shadow-inputError focus:border-red focus:shadow-inputError',
          hasWarning &&
            'border-yellow-600 text-yellow-600 placeholder-yellow-600 caret-yellow-600 hover:shadow-inputError focus:border-yellow-600 focus:shadow-inputError',
          isDisabled &&
            'cursor-not-allowed border-grey-400 bg-white text-grey-400 placeholder-grey-400 shadow shadow-grey-400 hover:shadow-grey-400 focus:border-grey-400',
          readOnly &&
            'cursor-not-allowed border-grey-650 bg-transparent text-grey-650 placeholder-grey-650 shadow shadow-grey-400 hover:shadow-grey-400 focus:border-grey-400 focus:text-grey-650 focus:placeholder-grey-650',
          isLabelWithingInput && 'peer pl-8',
          className,
        ),
      ),
    [className, hasWarning, isDisabled, isInError, isLabelWithingInput, readOnly],
  );
};
